import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ namespace, type, folder, document }) =>
    present(
      repository
        .updateDocument(namespace, type, folder, document)
        .then((document) => ({ namespace, type, folder, document }))
        .catch(() => Promise.reject({ namespace, type, folder, document })),
    );
}

export type { Interactor };

export { createInteractor };
